import { createSDSCollection } from './createSDSCollection';
import { createSDSCollectionItem } from './createSDSCollectionItem';

/**
 * Service to create both collection and item in one shot in SDS.
 * @param collectionName Collection in which the item is to be updated
 * @param itemClass Item Class to be put if a new item is to be created inside a collection
 * @param body Key value pairs to be updated
 * unexpected errors which are reported: Please do not store EMPTY ARRAYS in SDS, it will throw an error saying CollectionTypeNameRequired
 */
export async function createSDSCollectionAndItem(
    collectionName: string,
    itemClass: string,
    body: any
): Promise<any> {
    const collectionResponse = await createSDSCollection(collectionName);

    if (collectionResponse?.Id) {
        return createSDSCollectionItem(collectionName, itemClass, body);
    }
    return collectionResponse;
}
